import { toast } from "react-toastify";

/**
 * Hook useToast - Wrapper para react-toastify
 * Compatível com a interface usada no Dashboard moderno
 */
export const useToast = () => {
  const success = (message, options = {}) => {
    return toast.success(message, options);
  };

  const error = (message, options = {}) => {
    return toast.error(message, options);
  };

  const warning = (message, options = {}) => {
    return toast.warning(message, options);
  };

  const info = (message, options = {}) => {
    return toast.info(message, options);
  };

  const showToast = (message, type = "info", options = {}) => {
    switch (type) {
      case "success":
        return success(message, options);
      case "error":
        return error(message, options);
      case "warning":
        return warning(message, options);
      default:
        return info(message, options);
    }
  };

  return {
    success,
    error,
    warning,
    info,
    showToast,
    removeToast: toast.dismiss,
    removeAllToasts: () => toast.dismiss(),
  };
};

export default useToast;

